<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' class="header"></Header>
    <div class="content">
      <Planbanner></Planbanner>
      <Plateintroduce></Plateintroduce>
      <Apply></Apply>
      <Features></Features>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Planbanner from '@/components/plan/banner'
import Plateintroduce from '@/components/plan/plateintroduce'
import Apply from '@/components/plan/apply'
import Features from '@/components/plan/features'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Plan',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'plan'
    }
  },
  components: {
    Header,
    Planbanner,
    Plateintroduce,
    Apply,
    Features,
    Footer
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.content{
  margin-top: 120px;
  min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/components/plan/Plan.vue